import React from 'react';

import { useCompanyInfo } from '@investown/fe/api-sdk';

import SkeletonRow from 'components/SkeletonRow';

const CompanyName: React.FC<{ companyId: string }> = ({ companyId }) => {
  const { data, isLoading, isIdle } = useCompanyInfo(companyId);

  return isLoading || isIdle ? <SkeletonRow width={70} /> : <span>{data?.name}</span>;
};

export default CompanyName;
